import { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './empty-state.i18n';
import { Description, Image } from './empty-state.styled';
import firewallKeySvg from './firewall-key.svg';

export type Props = {
  headerMessage: FormattedMessage.MessageDescriptor;
};

const NoAccessibleRelevantEntityEmptyState = (props: Props) => {
  const { headerMessage } = props;

  return (
    <Fragment>
      <Image alt="" src={firewallKeySvg} />
      <h3>
        <FormattedMessage {...headerMessage} />
      </h3>
      <Description>
        <FormattedMessage
          {...messages.noAccessToRelevantProjectOrSiteDescription}
        />
      </Description>
    </Fragment>
  );
};

export const NoAccessibleRelevantProjectsEmptyState = () => (
  <NoAccessibleRelevantEntityEmptyState
    headerMessage={messages.noAccessToRelevantProjectsHeader}
  />
);

export const NoAccessibleRelevantSitesEmptyState = () => (
  <NoAccessibleRelevantEntityEmptyState
    headerMessage={messages.noAccessToRelevantSitesHeader}
  />
);
